import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-l-signpost",
  "use": "icon-l-signpost-usage",
  "viewBox": "0 0 165 165",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 165 165\" id=\"icon-l-signpost\"><path d=\"M80 22v122h6V22zm-2 24V22a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6h42l12 13-12 13H88v90a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V72H36L24 59l12-13zm0 2H36.876L26.722 59l10.154 11H78zm10-18v22h41.124l10.154-11-10.154-11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol